import { AppointmentsAPI } from "../../../../api/appointments";
import { throwErrorToastrAsync } from "../../../../utils";
import { IAppointmentImportForm, setAppointmentImportFormLoading } from "../../../reducers/appointment/appoitmentImport/form";
import { setAppointmentImportListData } from "../../../reducers/appointment/appoitmentImport/list";

const appointmentsAPI = new AppointmentsAPI();

export const ImportAppointmentAction = (form: IAppointmentImportForm, fileExtension?: any): any => {
    return async (dispatch: any) => {
        try {
            dispatch(setAppointmentImportFormLoading(true));
            let response: any = null;

            if (fileExtension === "txt") {
                response = await appointmentsAPI.importAppointmentText(form);
            }

            if (fileExtension === "json") {
                response = await appointmentsAPI.importAppointment(form);
            }

            if (fileExtension === "document") {
                response = await appointmentsAPI.importAppointmentDocument(form);
            }

            dispatch(setAppointmentImportListData(response));

            return true;
        } catch (error) {
            throwErrorToastrAsync(error);
        } finally {
            dispatch(setAppointmentImportFormLoading(false));
        }
    };
};
